import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	field: {
		position: "relative",
	},
	control: {
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		columnGap: tokens.spacingHorizontalXS,
		rowGap: tokens.spacingVerticalXXS,
		padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalS}`,
		border: `1px solid ${tokens.colorNeutralStroke1}`,
		borderRadius: tokens.borderRadiusMedium,
		backgroundColor: tokens.colorNeutralBackground1,
		// Griffel has no borderColor, so the focus state restates the whole border with the accent colour.
		":focus-within": {
			border: `1px solid ${tokens.colorCompoundBrandStroke}`,
		},
	},
	input: {
		flexGrow: 1,
		minWidth: "120px",
		border: "none",
		// A little room before the text so the placeholder and what is typed do not sit against the
		// chip before them.
		padding: `${tokens.spacingVerticalSNudge} 0 ${tokens.spacingVerticalSNudge} ${tokens.spacingHorizontalXS}`,
		backgroundColor: "transparent",
		color: tokens.colorNeutralForeground1,
		fontFamily: tokens.fontFamilyBase,
		fontSize: tokens.fontSizeBase300,
		":focus": {
			outlineStyle: "none",
		},
		"::placeholder": {
			color: tokens.colorNeutralForeground4,
		},
	},
	// Overlays the fields below instead of taking space in the form's flow.
	suggestions: {
		position: "absolute",
		top: "100%",
		left: 0,
		right: 0,
		zIndex: 1,
		marginTop: tokens.spacingVerticalXXS,
		padding: `${tokens.spacingVerticalXXS} 0`,
		border: `1px solid ${tokens.colorNeutralStroke1}`,
		borderRadius: tokens.borderRadiusMedium,
		backgroundColor: tokens.colorNeutralBackground1,
		boxShadow: tokens.shadow16,
	},
	// The dialog scrolls, so the list of the last field would be clipped by its bottom edge.
	suggestionsAbove: {
		top: "auto",
		bottom: "100%",
		marginTop: 0,
		marginBottom: tokens.spacingVerticalXXS,
	},
	suggestionActive: {
		backgroundColor: tokens.colorNeutralBackground1Hover,
	},
	suggestion: {
		padding: `${tokens.spacingVerticalSNudge} ${tokens.spacingHorizontalM}`,
		cursor: "pointer",
		color: tokens.colorNeutralForeground1,
		fontSize: tokens.fontSizeBase300,
		":hover": {
			backgroundColor: tokens.colorNeutralBackground1Hover,
		},
	},
	suggestionList: {
		maxHeight: "180px",
		overflowY: "auto",
	},
	suggestionHint: {
		padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalM}`,
		borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
		color: tokens.colorNeutralForeground4,
		fontSize: tokens.fontSizeBase200,
	},
	suggestionMessage: {
		padding: `${tokens.spacingVerticalSNudge} ${tokens.spacingHorizontalM}`,
		color: tokens.colorNeutralForeground4,
		fontSize: tokens.fontSizeBase300,
	},
	dialogContent: {
		display: "flex",
		flexDirection: "column",
		rowGap: tokens.spacingVerticalL,
		padding: `${tokens.spacingVerticalXS} 0`,
	},
	buttonsContainer: {
		display: "flex",
		justifyContent: "flex-end",
		columnGap: tokens.spacingHorizontalS,
		marginTop: tokens.spacingVerticalL,
	},
	chips: {
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		columnGap: tokens.spacingHorizontalS,
		rowGap: tokens.spacingVerticalXS,
		// The left margin matches the search input above and the right matches its row, so the
		// chips line up with the box they filter and wrap at the same edge.
		margin: `0 ${tokens.spacingHorizontalS} ${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
	},
});
